import React, { useState } from 'react'
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import { useAppContext } from '../context/AppContext';
import toast from 'react-hot-toast';

const Signup = () => {

    const { axios, setToken, navigate } = useAppContext();

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        confirmPassword: "",
    })

    const [showPassword, setShowPassword] = useState(false);

    function changeHandler(event) {
        setFormData((prevData) => (
            {
                ...prevData,
                [event.target.name]: event.target.value,
            }
        ))
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (formData.password !== formData.confirmPassword) {
                return toast.error("Password should be same");
            }
            const { data } = await axios.post("/api/admin/signup", { firstName: formData.firstName, lastName: formData.lastName, email: formData.email, password: formData.password });

            if (data.success) {
                // console.log('data :', data);
                toast.success("Register Successful");
                setToken(data.token);
                localStorage.setItem('token', data.token);
                axios.defaults.headers.common['Authorization'] = data.token;
                navigate("/");
            }
            else {
                toast.error(data.message);
            }
        } catch (error) {
            toast.error(error.message);
        }
    }

    return (
        <div className='w-full flex justify-center items-center'>
            <form
                onSubmit={handleSubmit}
                className="w-full max-w-lg bg-white rounded-xl shadow-lg p-8 space-y-6"
            >
                <h2 className="text-2xl font-semibold text-center text-gray-800">
                    Create Account
                </h2>
                <p className="text-sm text-center text-gray-500">
                    Register to access the admin dashboard
                </p>

                {/* First & Last Name */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-600 mb-1">
                            First Name <sup className="text-red-500">*</sup>
                        </label>
                        <input
                            required
                            type="text"
                            name="firstName"
                            value={formData.firstName}
                            onChange={changeHandler}
                            placeholder="Enter first name"
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-600 mb-1">
                            Last Name <sup className="text-red-500">*</sup>
                        </label>
                        <input
                            required
                            type="text"
                            name="lastName"
                            value={formData.lastName}
                            onChange={changeHandler}
                            placeholder="Enter last name"
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary"
                        />
                    </div>
                </div>

                {/* Email */}
                <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">
                        Email Address <sup className="text-red-500">*</sup>
                    </label>
                    <input
                        required
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={changeHandler}
                        placeholder="Enter email address"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary"
                    />
                </div>

                {/* Password & Confirm Password */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className="relative">
                        <label className="block text-sm font-medium text-gray-600 mb-1">
                            Password <sup className="text-red-500">*</sup>
                        </label>
                        <input
                            required
                            type={showPassword ? "text" : "password"}
                            name="password"
                            value={formData.password}
                            onChange={changeHandler}
                            placeholder="Enter password"
                            className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary"
                        />
                        <span
                            onClick={() => setShowPassword(prev => !prev)}
                            className="absolute right-3 top-9 cursor-pointer text-gray-500"
                        >
                            {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                        </span>
                    </div>

                    <div className="relative">
                        <label className="block text-sm font-medium text-gray-600 mb-1">
                            Confirm Password <sup className="text-red-500">*</sup>
                        </label>
                        <input
                            required
                            type={showPassword ? "text" : "password"}
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={changeHandler}
                            placeholder="Confirm password"
                            className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary"
                        />
                    </div>
                </div>

                {/* Submit */}
                <button
                    type="submit"
                    className="w-full bg-primary text-white py-2 rounded-lg font-medium hover:bg-primary/90 transition"
                >
                    Create Account
                </button>
            </form>
        </div>

    )
}

export default Signup